<template>

  <el-dialog
    title="添加编码"
    :visible.sync="dialogVisible"
    width="30%"
    @open="handleBeforeOpen"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item :label="$t('lcd.Editor.Encoding Type')" prop="type">
        <el-select v-model="form.type" placeholder="请选择编码类型" size="small">
          <el-option label="QRCode" value="0" key="0"></el-option>
          <el-option label="BarCode" value="1" key="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.type === '0'" :label="$t('lcd.Editor.Encoding Content')">
        <el-select v-model="form.contentType" placeholder="请选择编码内容" size="small">
          <el-option label="链接" value="0" key="0"></el-option>
          <el-option label="文本" value="1" key="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.type === '0' && form.contentType === '0'" label="网页地址：" prop="url">
        <el-input
          ref="url"
          v-model="form.url"
          size="small"
          placeholder="请输入网页地址"
          @keypress.enter.native.prevent="handleClickAdd"
          @submit.native.prevent
        />
      </el-form-item>
      <el-form-item v-if="form.type === '1' || form.contentType === '1'" :label="$t('lcd.Editor.Text')" prop="url">
        <el-input
          ref="url"
          v-model="form.text"
          size="small"
          placeholder="请输入文字类容"
          @keypress.enter.native.prevent="handleClickAdd"
          @submit.native.prevent
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClickAdd">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import store from '../../../store/index.js'
import { attrBarCode } from '../../../utils/component-attribute'
import { attrQRCode } from '../../../utils/component-attribute'

export default {
  name: 'AddCode',
  inject: ['getNewComponentId'],
  data() {
    return {
      form: {
        url: ''
      },
      rules: {
        type: [
          { required: true, message: '请选择编码类型', trigger: 'blur' }
        ],
        contentType: [
          { required: true, message: '请输选择编码内容', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请输入网页地址', trigger: 'blur' }
        ],
        text: [
          { required: true, message: '请输入文字文本', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return store.state.addCodeDialogVisible
      },
      set(val) {
        store.updateAddCodeDialogVisible(val)
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.url.focus()
        }, 100)
      }
    }
  },
  methods: {
    handleBeforeOpen() {
      this.form = {
        url: 'http://',
        type: '0',
        contentType: '0'
      }
    },
    handleClickAdd() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const date = new Date();
          if (this.form.type === "0"){
            const conf = JSON.parse(JSON.stringify(attrQRCode))
            conf.componentId = this.getNewComponentId()
            conf.imgList.push({
              duration: 3,
              imgSrc: "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fbpic.588ku.com%2Felement_origin_min_pic%2F00%2F31%2F53%2F8956d2eaced73db.jpg%21rw400&refer=http%3A%2F%2Fbpic.588ku.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1620285517&t=9d6f004e3968b33474fcdc0700e04eb3",
              imgId: date.getTime()
            })
            store.addComponent(conf)
            this.dialogVisible = false
          }else {
            const conf = JSON.parse(JSON.stringify(attrBarCode))
            conf.componentId = this.getNewComponentId()
            conf.imgList.push({
              duration: 3,
              imgSrc: "https://ss1.baidu.com/9vo3dSag_xI4khGko9WTAnF6hhy/zhidao/pic/item/1f178a82b9014a9007d46290ab773912b31bee31.jpg",
              imgId: date.getTime()
            })
            store.addComponent(conf)
            this.dialogVisible = false
          }

        }
      })
    }
  }
}
</script>
